import * as Sentry from "@sentry/react";
import cookie from "cookie";
import { HashRouter, Route, Routes } from "react-router-dom";
import { Provider } from 'react-redux'
import { useEffect, useState } from "react";
import {ThunkDispatch} from "@reduxjs/toolkit";
import { useNavigate } from "react-router-dom";
import {connect, useDispatch } from "react-redux"
import {currentUserActions} from './reducers/currentUser'

import { OpenAPI } from "./api";
import { loadMockModeFromStorage } from "./api/mockUtils";
import store from "./store"
import MultiTabError from "./components/MultiTabError"
import ProtectedPage from "./components/ProtectedPage";
import Home from "./components/Home";
import Login from "./components/Login";
import AccountManage from './pages/AccountManage'
import AccountCreate from './components/account_manage/AccountCreate'
import AccountEdit from './components/account_manage/AccountEdit'
import AccountView from './components/account_manage/AccountView'
import MockModeToggle from "./components/MockModeToggle";
import GeneralUserManage from "./pages/GeneralUserManage";
import SessionExpiredModal from "./components/SessionExpiredModal";

// モックモードの設定をローカルストレージから読み込む
loadMockModeFromStorage();

// 本番環境ではモックモードを使用しない
const isProduction = process.env.NODE_ENV === 'production';
if (isProduction) {
  // 本番環境ではモックモードを無効化
  OpenAPI.USE_MOCK = false;
}

// モックモードトグルの表示設定（常に非表示）
const showMockToggle = false;

OpenAPI.interceptors.request.use((request) => {
  const { csrftoken } = cookie.parse(document.cookie);
  if (request.headers && csrftoken) {
    request.headers["X-CSRFTOKEN"] = csrftoken;
  }
  return request;
});

const AppRoutes = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch<ThunkDispatch<any, any, any>>()
  const [isCurrentTab, setIsCurrentTab] = useState(true);
  // const logOut = () => {dispatch(currentUserActions.signOutUser(navigate))}
  useEffect(() => {
    // const channel = new BroadcastChannel('tab');
    // channel.postMessage('first-tab');
    // const msgProcess = (msg: any) => {
    //   if (msg.data === 'first-tab') {
    //     channel.postMessage('please-close-tab');
    //     return
    //   }
    //   if (msg.data === 'please-close-tab') {
    //     channel.removeEventListener('message', msgProcess)
    //     // window.removeEventListener("beforeunload", logOut);
    //     setIsCurrentTab(false)
    //     return
    //   }
    // }

    // channel.addEventListener('message', msgProcess);
    // // window.addEventListener("beforeunload", logOut);
  }, []);
  if (!isCurrentTab)
    return (<MultiTabError />)

  return (
    <>
      <Routes>
        <Route path="login" element={<Login />} />
      </Routes>
      <Routes>
        <Route path="" element={<ProtectedPage><Home /></ProtectedPage>} />
      </Routes>
      <Routes>
        <Route path="account-create" element={<ProtectedPage><AccountCreate /></ProtectedPage>} />
      </Routes>
      <Routes>
        <Route path="account-edit/:id" element={<ProtectedPage><AccountEdit /></ProtectedPage>} />
      </Routes>
      <Routes>
        <Route path="account-view/:id" element={<ProtectedPage><AccountView /></ProtectedPage>} />
      </Routes>
      <Routes>
        <Route path="general-user-manage" element={<ProtectedPage><GeneralUserManage /></ProtectedPage>} />
      </Routes>
    </>
  )
}

const App = () => {

  return (
    <Sentry.ErrorBoundary fallback={<p>An error has occurred</p>}>
      <Provider store={store}>
        <HashRouter>
          <AppRoutes />
          {showMockToggle && <MockModeToggle />}
          <SessionExpiredModal />
        </HashRouter>
      </Provider>
    </Sentry.ErrorBoundary>
  )
}

export default App;
